import { InjectionToken } from '@angular/core';

/** Hook opcional: 1ª abertura da aba WhatsApp no Bardo Admin. */
export const PRODUCT_TOUR_ON_WHATSAPP_TAB = new InjectionToken<() => void>(
  'PRODUCT_TOUR_ON_WHATSAPP_TAB'
);
